export default "__VITE_ASSET__9pQN$L0i__"